import { makeApiCall, makeFormApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET MEMBER ATTENDANCE REPORT START *********************** */
export const memberAttendanceReportListGet = (listData: any) => {
	const data = {
		GetMemberAttendanceReportToken: listData,
	};
	const url = `${API_URL}FetchMemberAttendanceDetailsReport`;
	return makeApiCall(url, data);
};
/** ***************** GET MEMBER ATTENDANCE REPORT END *********************** */

/** ***************** FETCH MEMBER ATTENDANCE REPORT EXCEL DETAILS START *********************** */
export const memberAttendanceReportExcelListGet = (listData: any) => {
	const params = new URLSearchParams();
	params.append('FetchMemberAttendanceReportToken', listData);
	const url = `${API_URL}Excel/MemberAttendanceReportExportToken.php`;
	return makeFormApiCall(url, params);
};
/** ***************** FETCH MEMBER ATTENDANCE REPORT EXCEL DETAILS END *********************** */
